var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "code-search-right" }, [
        _c(
          "div",
          { staticClass: "csr-left" },
          [
            _c(
              "el-input",
              {
                staticStyle: { width: "230px", "margin-right": "15px" },
                attrs: {
                  placeholder: "请输入素材内容",
                  size: "mini",
                  maxlength: "50",
                  clearable: ""
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch()
                  }
                },
                model: {
                  value: _vm.getDataParams.keyWord,
                  callback: function($$v) {
                    _vm.$set(_vm.getDataParams, "keyWord", $$v)
                  },
                  expression: "getDataParams.keyWord"
                }
              },
              [_c("template", { slot: "prepend" }, [_vm._v("素材内容")])],
              2
            ),
            _c(
              "el-button-group",
              [
                _c("el-button", { attrs: { size: "mini" } }, [
                  _vm._v(" 一级分类 ")
                ]),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择", size: "mini" },
                    model: {
                      value: _vm.getDataParams.topTypeId,
                      callback: function($$v) {
                        _vm.$set(_vm.getDataParams, "topTypeId", $$v)
                      },
                      expression: "getDataParams.topTypeId"
                    }
                  },
                  _vm._l(_vm.oneOptions, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.typeName, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-button-group",
              [
                _c("el-button", { attrs: { size: "mini" } }, [
                  _vm._v(" 二级分类 ")
                ]),
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择",
                      size: "mini",
                      disabled: !_vm.getDataParams.topTypeId
                    },
                    model: {
                      value: _vm.getDataParams.middleTypeId,
                      callback: function($$v) {
                        _vm.$set(_vm.getDataParams, "middleTypeId", $$v)
                      },
                      expression: "getDataParams.middleTypeId"
                    }
                  },
                  _vm._l(_vm.twoOptions, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.typeName, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-button-group",
              [
                _c("el-button", { attrs: { size: "mini" } }, [
                  _vm._v(" 三级分类 ")
                ]),
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择",
                      size: "mini",
                      disabled: !_vm.getDataParams.middleTypeId
                    },
                    model: {
                      value: _vm.getDataParams.downTypeId,
                      callback: function($$v) {
                        _vm.$set(_vm.getDataParams, "downTypeId", $$v)
                      },
                      expression: "getDataParams.downTypeId"
                    }
                  },
                  _vm._l(_vm.threeOptions, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.typeName, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-button",
              { attrs: { size: "mini" }, on: { click: _vm.clearParams } },
              [_vm._v("清空")]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.handleSearch()
                  }
                }
              },
              [_vm._v("查询")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "csr-right" },
          [
            _vm.MaterOptionState
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.newMaterial }
                  },
                  [_vm._v("新建素材")]
                )
              : _vm._e(),
            _vm.MaterOptionState
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.showBatchTypeDialog }
                  },
                  [_vm._v("批量修改分类")]
                )
              : _vm._e(),
            _vm.MaterOptionState
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function($event) {
                        _vm.dialogVisiClass = true
                      }
                    }
                  },
                  [_vm._v("管理分类")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          ref: "cusChatTable",
          staticStyle: { "font-size": "13px" },
          attrs: {
            size: "small",
            data: _vm.tableData,
            fit: "",
            align: "center",
            "header-cell-style": { background: "#F9F9F9" },
            height: _vm.MaterOptionState
              ? "calc(100vh - 235px)"
              : "calc(60vh - 92px)",
            "highlight-current-row": true
          },
          on: {
            "row-dblclick": _vm.handleDbclick,
            "selection-change": _vm.handleSelectionChange,
            "current-change": _vm.handleCurrentChange
          }
        },
        [
          _vm.MaterOptionState
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: "素材内容",
              "min-width": "400",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.content
                      ? _c("div", { staticClass: "item-content" }, [
                          _vm._v(" " + _vm._s(scope.row.content) + " ")
                        ])
                      : _vm._e(),
                    scope.row.chatMaterialResources &&
                    scope.row.chatMaterialResources.length > 0
                      ? _c(
                          "div",
                          { staticClass: "item-image" },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              _vm._l(scope.row.chatMaterialResources, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "el-col",
                                  {
                                    key: index,
                                    staticStyle: {
                                      "max-height": "50px",
                                      overflow: "hidden"
                                    },
                                    attrs: { span: 1.5 }
                                  },
                                  [
                                    item.type == "img" || item.type == "image"
                                      ? _c("el-image", {
                                          staticStyle: {
                                            width: "50px",
                                            cursor: "pointer"
                                          },
                                          attrs: {
                                            src: item.fileFullUrl,
                                            fit: "fill"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.previewTableImage(
                                                item.fileFullUrl
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    item.type == "mp4"
                                      ? _c(
                                          "div",
                                          { staticClass: "video-img" },
                                          [
                                            _c(
                                              "video",
                                              {
                                                staticStyle: {
                                                  width: "50px",
                                                  height: "50px",
                                                  cursor: "pointer"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.previewVideoImage(
                                                      item.fileFullUrl
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("source", {
                                                  attrs: {
                                                    src: item.fileFullUrl
                                                  }
                                                })
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-video-play video-icon",
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.previewVideoImage(
                                                    item.fileFullUrl
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.handleShowLink(scope.row)
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "background-color": "#f5f7fa"
                              }
                            },
                            [
                              _c("el-image", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-right": "10px"
                                },
                                attrs: {
                                  src: scope.row.chatMaterialLink
                                    ? scope.row.chatMaterialLink.pictureFullUrl
                                    : "",
                                  fit: "fill"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.previewTableImage(
                                      scope.row.chatMaterialLink.pictureFullUrl
                                    )
                                  }
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.chatMaterialLink
                                          ? scope.row.chatMaterialLink.content
                                          : ""
                                      )
                                    )
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.chatMaterialLink
                                          ? scope.row.chatMaterialLink.title
                                          : ""
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm.getfTime(scope.row.createTime)))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "materialTopTypeId",
              label: "一级分类",
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.chatMaterialTypes.find(function(item) {
                            return item.id == scope.row.materialTopTypeId
                          }) &&
                            scope.row.chatMaterialTypes.find(function(item) {
                              return item.id == scope.row.materialTopTypeId
                            }).typeName
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "materialMiddleTypeId",
              label: "二级分类",
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.chatMaterialTypes.find(function(item) {
                            return item.id == scope.row.materialMiddleTypeId
                          }) &&
                            scope.row.chatMaterialTypes.find(function(item) {
                              return item.id == scope.row.materialMiddleTypeId
                            }).typeName
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "materialDownTypeId",
              label: "三级分类",
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.chatMaterialTypes.find(function(item) {
                            return item.id == scope.row.materialDownTypeId
                          }) &&
                            scope.row.chatMaterialTypes.find(function(item) {
                              return item.id == scope.row.materialDownTypeId
                            }).typeName
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "orderNo", label: "排序", "min-width": "120" }
          }),
          _c("el-table-column", {
            attrs: { prop: "createByName", label: "创建人", "min-width": "200" }
          }),
          _vm.MaterOptionState
            ? _c("el-table-column", {
                attrs: { label: "操作", "min-width": "200" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          true
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "table-button",
                                  attrs: { type: "text", size: "small" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleEdit(
                                        scope.$index,
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          true
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "table-button",
                                  attrs: { type: "text", size: "small" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleDel(
                                        scope.$index,
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3484276038
                )
              })
            : _vm._e()
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("el-image", {
        ref: "myImg",
        staticClass: "my-preview-image",
        attrs: { src: _vm.previewUrl, "preview-src-list": _vm.previewSrcList }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "video-dialog",
          staticStyle: { "margin-top": "0vh" },
          attrs: {
            visible: _vm.videoShow,
            width: "400px",
            "close-on-click-modal": "",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.videoShow = $event
            }
          }
        },
        [
          _c(
            "video",
            { attrs: { width: "100%", height: "auto", controls: "controls" } },
            [_c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } })]
          )
        ]
      ),
      _c("MaterialDialog", {
        ref: "materialDialog",
        attrs: { emitTypeList: _vm.emitTypeList },
        on: {
          preView: _vm.previewTableImage,
          reGet: function($event) {
            _vm.reGet()
            _vm.getLevelList()
          }
        }
      }),
      _vm.dialogVisiClass
        ? _c("manageClassDialog", {
            attrs: { dialogVisiClass: _vm.dialogVisiClass },
            on: {
              "update:dialogVisiClass": function($event) {
                _vm.dialogVisiClass = $event
              },
              "update:dialog-visi-class": function($event) {
                _vm.dialogVisiClass = $event
              },
              getData: function($event) {
                _vm.getData()
                _vm.getLevelList()
              }
            }
          })
        : _vm._e(),
      _c("batchTypeDialog", {
        attrs: {
          batchDialogShow: _vm.batchTypeShowdialog,
          emitTypeList: _vm.emitTypeList,
          multipleSelectionData: _vm.multipleSelection
        },
        on: {
          "update:batchDialogShow": function($event) {
            _vm.batchTypeShowdialog = $event
          },
          "update:batch-dialog-show": function($event) {
            _vm.batchTypeShowdialog = $event
          },
          getData: function($event) {
            _vm.getData()
            _vm.getLevelList()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }